import { useState } from 'react';

const ArtworkCard = ({ artwork, onClick }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  // Get the primary image (first from images array, or fallback to image_url)
  const primaryImage = artwork.images && artwork.images.length > 0 
    ? artwork.images[0] 
    : artwork.image_url;

  return (
    <div 
      className="masonry-item cursor-pointer group"
      onClick={() => onClick && onClick(artwork)}
      data-testid={`artwork-card-${artwork.id}`}
    >
      <div className="relative overflow-hidden bg-neutral-900 border border-white/10">
        {/* Loading placeholder */}
        {!isLoaded && (
          <div className="absolute inset-0 img-loading" />
        )}
        
        {/* Image */}
        <img
          src={primaryImage}
          alt={artwork.title}
          className={`w-full h-auto object-cover transition-all duration-500 group-hover:scale-105 ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onLoad={() => setIsLoaded(true)}
          loading="lazy"
        />

        {/* Multi-image indicator */}
        {artwork.images && artwork.images.length > 1 && (
          <div className="absolute top-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-sm">
            1/{artwork.images.length}
          </div>
        )}

        {/* Hover overlay */}
        <div className="absolute inset-0 bg-black/90 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center justify-center p-6">
          <h3 className="font-heading text-xl font-semibold text-white text-center mb-2">
            {artwork.title}
          </h3>
          <p className="text-white/60 text-sm">
            {artwork.dimensions}
          </p>
          {artwork.year && (
            <p className="text-teal-400 text-xs mt-2 uppercase tracking-wider">
              {artwork.year}
            </p>
          )}
        </div>
      </div>

      {/* Info below image (visible on mobile) */}
      <div className="pt-4 md:hidden">
        <h3 className="font-heading text-lg font-medium text-white">
          {artwork.title}
        </h3>
        <p className="text-white/50 text-sm">
          {artwork.dimensions}
        </p>
      </div>
    </div>
  );
};

export default ArtworkCard;
